import React from "react";
import PropTypes from "prop-types";
import styles from "../../css/inputs/InputWithLabel.module.css";

const InputWithLabel = ({
  id,
  label,
  type,
  value,
  onChange,
  autoComplete,
  icon,
  onIconClick,
  iconColor,
  error, // Nová vlastnost pro chybovou zprávu
  containerClass = "",
  inputClass = "",
  labelClass = "",
}) => {
  return (
    <div className={`${styles.inputContainer} ${containerClass}`}>
      {label && (
        <label htmlFor={id} className={`${styles.label} ${labelClass}`}>
          {label}
        </label>
      )}
      <div className={styles.inputWithIcon}>
        <input
          type={type}
          id={id}
          value={value}
          onChange={onChange}
          autoComplete={autoComplete}
          className={`${styles.input} ${inputClass} ${error ? styles.inputError : ""}`}
        />
        {icon && (
          <span
            className={styles.icon}
            onClick={onIconClick}
            style={{ color: iconColor }}
          >
            {icon}
          </span>
        )}
      </div>
      {error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
};

InputWithLabel.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  autoComplete: PropTypes.string,
  icon: PropTypes.element,
  onIconClick: PropTypes.func,
  iconColor: PropTypes.string,
  error: PropTypes.string,
  containerClass: PropTypes.string,
  inputClass: PropTypes.string,
  labelClass: PropTypes.string,
};

export default InputWithLabel;
